<template>
	<div class="app-container">
		<HospitalSearchForm @searchForm="searchFormHandler"></HospitalSearchForm>
		<Button
			@showDialogAdd="showDialogAddHandler"
			@showDialogEdit="showDialogEditHandler"
			@showDelete="showDeleteHandler"
			:selectData_p="selectData"
			:delTips_p="delTips"
			:authorize_p="'hospital'"
		></Button>
		<!--表格渲染-->
		<Table ref="tableDom" :data.sync="tableData" :tableColumn_p="tableColumn" :selectData_p.sync="selectData">
			<el-table-column label="LOGO">
				<template slot-scope="scope">
					
					<el-image
						class="devBaseFormLogoStr"
						style="width:30px;height:30px; "
						:src="orgLogo + scope.row.logo"
						:preview-src-list="[orgLogo + scope.row.logo]"
					></el-image>
					<!-- <img :src="orgLogo + scope.row.logo" width="30" height="30" alt="" srcset="" /> -->
				</template>
			</el-table-column>
			<el-table-column label="创建时间">
				<template slot-scope="scope">{{ scope.row.createDate | formatDate }}</template>
			</el-table-column>
			<el-table-column label="操作" align="left" fixed="right">
				<template slot-scope="scope">
					<el-button
						id="btn-update-row"
						type="primary"
						v-authorize="{ name: 'update', type: 'hospital', id: 'btn-update-row' }"
						@click="editSingleHandler(scope.row)"
					>
						编辑
					</el-button>
					<el-button
						id="btn-remove-row"
						type="danger"
						v-authorize="{ name: 'remove', type: 'hospital', id: 'btn-remove-row' }"
						@click="deleteSingleHandler(scope.row)"
					>
						删除
					</el-button>
				</template>
			</el-table-column>
		</Table>
		<Pagination :total="total" :pageIndex_p.sync="pageIndex" :pageSize_p.sync="pageSize"></Pagination>
		<Dialog :title="dialogTitle" :visible.sync="isShowAEDialog">
			<HospitalAddForm
				v-if="isShowAEDialog"
				:isShowAEDialog_p.sync="isShowAEDialog"
				:isRefreshList_p.sync="isRefreshList"
				:isRefreshListAll_p.sync="isRefreshListAll"
				:selectData_p="selectData"
				:editId_p="editId"
			></HospitalAddForm>
		</Dialog>
	</div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { hospitalListService, hospitalDeleteService, hospitalDetailService } from '@s/system/HospitalService';
import Dialog from '@c/ui/Dialog';
import Button from '@c/ui/Button';
import Table from '@c/ui/Table';
import Pagination from '@c/ui/Pagination';
import HospitalAddForm from '@f/system/hospital/HospitalAdd.form';
import HospitalSearchForm from '@f/system/hospital/HospitalSearch.form';
import ListMixin from '@m/List.mixin';
import { hgetStorage } from '@/util/htools.web';

export default {
	mixins: [ListMixin],
	components: {
		Table,
		Dialog,
		Pagination,
		Button,
		HospitalAddForm,
		HospitalSearchForm
	},
	data() {
		return {
			orgLogo: '',
			orgbusinesslicense: '',
			// 表格
			tableColumn: [
				{
					label: '医院名称',
					field: 'name',
					width: 200
				},
				{
					label: '医院等级',
					field: 'levelName'
				},
				{
					label: '官方网址',
					field: 'website'
				},
				{
					label: '联系电话',
					field: 'phone'
				},
				{
					label: '地址详情',
					field: 'address'
				}
			],
			delTips: '',
			currentUserOrganization: null
		};
	},
	computed: {
		dialogTitle() {
			return this.editId === -1 ? '新增医院' : '编辑医院';
		}
	},
	watch: {
		pageIndex(newValue) {
			this.pageIndex = newValue;
			this.hospitalList();
		},
		pageSize(newValue) {
			this.pageSize = newValue;
			this.hospitalList();
		},
		isRefreshList(newValue) {
			if (newValue) {
				this.hospitalList();
			}
		},
		isRefreshListAll(newValue) {
			if (newValue) {
				if (this.pageIndex === 1) {
					this.hospitalList();
				} else {
					this.pageIndex = 1;
				}
			}
		}
	},
	mounted() {
		this.hospitalList();
		this.currentUserOrganization = hgetStorage('organization');
		setTimeout(() => {
			this.orgLogo = `${this.$envConfig.imgHttp}${this.$envConfig.imgFile.orglogo}/`;
			this.orgbusinesslicense = `${this.$envConfig.imgHttp}${this.$envConfig.imgFile.orgbusinesslicense}/`;
		}, 1000);
	},
	methods: {
		async hospitalList() {
			const dataJson = {
				pageNum: this.pageIndex,
				pageSize: this.pageSize,
				...this.searchForm
			};
			const res = await hospitalListService(dataJson);
			this.listMixin(res);
		},
		showDialogAddHandler() {
			this.dialogAddHandlerMixin();
		},
		async showDialogEditHandler() {
			const editId = this.dialogEditHandlerMixin();
			const dataJson = {
				hospitalId: editId
			};
			const res = await hospitalDetailService(dataJson);
			this.selectData = [res];
			this.showDialogEditHandlerMixin();
		},
		async showDeleteHandler() {
			const ids = this.filterSelectIdsMixin();
			const dataJson = {
				id: ids
			};
			await hospitalDeleteService(dataJson);
			this.isRefreshList = true;
		},
		async editSingleHandler(row) {
			const dataJson = {
				hospitalId: row.id
			};
			const res = await hospitalDetailService(dataJson);
			this.editSingleHandlerMixin(res);
		},
		async deleteSingleHandler(row) {
			this.deleteSingleHandlerMixin(row);
		},
		searchFormHandler(searchForm) {
			this.searchFormHandlerMixin(searchForm);
			this.hospitalList();
		},
		editPasswordHandler(row) {
			this.isShowPasswordDialog = true;
			this.editId = row.id;
		}
	}
};
</script>
<style lang='less' scoped>
/deep/.el-image-viewer__close {
	top: 80px !important;
	color: #ffffff;
}
/deep/.el-image__error{
	line-height: 14px;
}

/deep/ .el-dialog {
	width: 1000px;
	overflow: hidden;
}
/deep/.el-dialog .el-form-item {
	width: 45%;
	margin-right: 15px;
	float: left;
}
</style>
